export default
    {
        path: 'XSJFeeRouter',
        //name: 'WorkflowFormOpen',
        component: () => import('../view/workflow/XSJFeeOpen.vue'),
        props: (route) => (
            {
                sapId:route.query.sapId,
                processDefinitionId: route.query.processDefinitionId,
                taskId2: route.query.taskId2,
                type: route.query.type,
                token:route.query.token,
                koaToken:route.query.koaToken,
                userId:route.query.userId,
                deviceType:route.query.deviceType,
                deviceName:route.query.deviceName,
                process_instance_id:route.query.process_instance_id,
                noticeId:route.query.noticeId,
                isBl:route.query.isBl,  //是否允许办理 0：不允许 1：允许 默认是1
                secondLoginType:route.query.secondLoginType,
                secondAssessToken:route.query.secondAssessToken,
                deviceId:route.query.deviceId,
            }
        ),
        children: [
            {
                path: "workflowAuditOther",
                //name: "workflowAuditOther",
                component: () => import('../view/workflow/WorkflowAuditOther.vue'),
                props: (route) => (
                    {
                        processDefinitionId: route.query.processDefinitionId,
                        taskId: route.query.taskId,
                        type: route.query.type
                    }
                )
            },
            {
                path: "workfloOpenSubForm",
                //name: "workfloOpenSubForm",
                component: () => import('../view/workflow/WorkflowFormSubOpen.vue'),
                props: (route) => (
                    {
                        processDefinitionId: route.query.processDefinitionId,
                        taskId: route.query.taskId,
                        type: route.query.type,
                        isCreate: route.query.isCreate,
                        editMode: route.query.editMode,
                        subTitle: route.query.subTitle,
                        subTableName: route.query.subTableName,
                        subTableAlignFieldName: route.query.subTableAlignFieldName,
                        recordIndex:route.query.recordIndex
                    }
                )
            }
        ]

    }



// WEBPACK FOOTER //
// ./src/router/XSJFeeRouter.js